export default [
    //VOLUNTEER SECTION
    {
        path: "/volunteer/townships",
        name: "VolunteerTownship",
        component: () => import("@/views/volunteer/Township.vue"),
        meta: {
            forAuth: true,
        },
    },
    {
        path: "/volunteer/townships/:township_id",
        name: "Volunteer",
        component: () => import("@/views/volunteer/Volunteer.vue"),
        meta: {
            forAuth: true,
        },
    },
    {
        path: "/volunteer/trainings/:id",
        name: "training",
        component: () => import("@/views/volunteer/training/Training.vue"),
        meta: {
            forAuth: true,
        },
    },
     {
        path: "/volunteer/create",
        name: "volunteer-create",
        component: () => import("@/views/volunteer/Create.vue"),
        meta: { forAuth: true },
    },
]